import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback, /* , useEffect, */useState } from 'react';
import { Modal } from '@beef/ui-kit';
import { StorySlideList } from "../StoryDetail/StoryDetailList";
import { setStoryViewed } from "../utils";
var StoryDetailsModal = function StoryDetailsModal(_ref) {
  var detailSliderSettings = _ref.detailSliderSettings,
    onClose = _ref.onClose,
    _onDetailClick = _ref.onDetailClick,
    onStoryView = _ref.onStoryView,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    detailStoryIndex = _ref.detailStoryIndex,
    setDetailStoryIndex = _ref.setDetailStoryIndex,
    storiesList = _ref.storiesList,
    setStoriesList = _ref.setStoriesList;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    viewedItems = _useState2[0],
    setViewedItems = _useState2[1];
  var handleSetStoryViewed = useCallback(function (index) {
    var story = storiesList[index];
    if (story) {
      onStoryView === null || onStoryView === void 0 ? void 0 : onStoryView(story);
      var storyId = story.id;
      if (viewedItems[storyId] || story.viewed) {
        return;
      }
      setStoryViewed(storyId);
      setViewedItems(_objectSpread(_objectSpread({}, viewedItems), {}, _defineProperty({}, storyId, true)));
    }
  }, [viewedItems, setViewedItems, storiesList, onStoryView]);
  var updateViewedItems = useCallback(function () {
    if (!Object.keys(viewedItems).length) {
      return;
    }
    var updatedPreviewList = storiesList.map(function (item) {
      if (viewedItems[item.id]) {
        return _objectSpread(_objectSpread({}, item), {}, {
          viewed: true
        });
      }
      return item;
    });
    setViewedItems({});
    setStoriesList(updatedPreviewList);
  }, [viewedItems, storiesList, setStoriesList]);
  var closeDetail = function closeDetail() {
    return setDetailStoryIndex(undefined);
  };
  var handleClose = useCallback(function () {
    closeDetail();
    updateViewedItems();
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [updateViewedItems, onClose]);
  var isOpenStory = isOpen || !!detailStoryIndex || detailStoryIndex === 0;
  return /*#__PURE__*/React.createElement(Modal, {
    isBodyScrollHiddenOnMobile: true,
    isCloseButtonVisible: false,
    isNoPadding: true,
    isOpen: isOpenStory,
    onClose: handleClose,
    theme: "dark",
    "data-t-id": "StoriesV2-StoryDetailsModal"
  }, isOpenStory && /*#__PURE__*/React.createElement(StorySlideList, {
    detailSliderSettings: detailSliderSettings,
    handleStoryViewed: handleSetStoryViewed,
    initialSlide: detailStoryIndex,
    onClose: handleClose,
    onDetailClick: function onDetailClick(e, detailData) {
      if (_onDetailClick) {
        _onDetailClick(e, detailData);
      }
    },
    onTimeoutLast: handleClose,
    stories: storiesList
  }));
};
export { StoryDetailsModal };